import { render, staticRenderFns } from "./HotelArea.vue?vue&type=template&id=ff7d2900&scoped=true"
import script from "./HotelArea.vue?vue&type=script&lang=js"
export * from "./HotelArea.vue?vue&type=script&lang=js"
import style0 from "./HotelArea.vue?vue&type=style&index=0&id=ff7d2900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7d2900",
  null
  
)

export default component.exports